import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import OptionIcon from '@lmt/unicorn-shared/app/icons/option-big.svg?react';
import React, { FC, useState } from 'react';
import clsx from 'clsx';

import styles from './DotMenu.module.scss';

export enum MenuDirection {
  TopRight = 1,
  BottomLeft = 2,
}

export interface DotMenuOption {
  title: string;
  onClick: () => void;
  disabled?: boolean;
  isDeleteItem?: boolean;
  isUnderLine?: boolean;
  icon?: React.ReactNode;
  isHidden?: boolean;
  testId?: string;
}

export interface DotMenuProps {
  options: DotMenuOption[];
  className?: string;
  direction?: MenuDirection;
  testId?: string;
  iconClassName?: string;
}

export const TableDotMenu: FC<DotMenuProps> = (props) => {
  const { options } = props;
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const handleClose = (event?: Object) => {
    (event as React.MouseEvent | React.KeyboardEvent)?.stopPropagation?.();
    setAnchorEl(null);
  };

  if (!options.length || options.every((option) => option.isHidden)) {
    return false;
  }

  return (
    <div className={props.className}>
      <IconButton
        disableFocusRipple={true}
        disableTouchRipple={true}
        disableRipple={true}
        className={styles.optionButton}
        aria-label="more"
        aria-controls="option-menu"
        aria-haspopup="true"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        data-test-id={props.testId}
      >
        <OptionIcon
          className={clsx(styles.optionButtonIcon, props.iconClassName)}
        />
      </IconButton>
      <Menu
        id="option-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        disablePortal={true} // fix #51253: menu remains open on another tab
        onClose={handleClose}
        transitionDuration={0}
        anchorOrigin={
          props.direction == MenuDirection.TopRight
            ? {
                vertical: 'top',
                horizontal: 'center',
              }
            : {
                vertical: 'bottom',
                horizontal: 'center',
              }
        }
        transformOrigin={
          props.direction == MenuDirection.TopRight
            ? {
                vertical: 'bottom',
                horizontal: 'left',
              }
            : {
                vertical: 'top',
                horizontal: 'right',
              }
        }
      >
        {options
          .filter((option) => !option.isUnderLine && !option.isHidden)
          .map((option) => (
            <MenuItem
              key={option.title}
              data-test-id={option.testId}
              className={
                option.isDeleteItem ? styles.deleteItem : styles.menuItem
              }
              disabled={option.disabled}
              onClick={(event) => {
                handleClose(event);
                setTimeout(option.onClick, 100);
              }}
            >
              <div className={styles.menuItemOption}>
                {option.icon}
                {option.title}
              </div>
            </MenuItem>
          ))}
        {options.some((option) => option.isUnderLine && !option.isHidden) &&
          options.some((option) => !option.isUnderLine && !option.isHidden) && (
            <Divider className={styles.divider} />
          )}
        {options
          .filter((option) => option.isUnderLine && !option.isHidden)
          .map((option) => (
            <MenuItem
              key={option.title}
              data-test-id={option.testId}
              className={
                option.isDeleteItem ? styles.deleteItem : styles.menuItemOption
              }
              disabled={option.disabled}
              onClick={(event) => {
                handleClose(event);
                option.onClick();
              }}
            >
              <div className={styles.menuItemOption}>{option.title}</div>
            </MenuItem>
          ))}
      </Menu>
    </div>
  );
};
